import { isValid as isValidIban } from 'iban'
import * as Yup from 'yup'

import { EMPTY_LIST } from '../../../constants/common'
import { CURRENCY_FORMAT_OPTIONS } from '../../../constants/currency'
import { REG_EXP_BIC } from '../../../constants/regExp'
import { formatNumberWithSeparators, parseAmount } from '../../../utils/number'

import {
  PROFILE_INFO_MONEY_MAX_AMOUNT,
  PROFILE_INFO_NOTES_FIELD_NAME,
  PROFILE_INFO_NOTES_MAX_LENGTH,
  ProfileInfoFieldType,
} from './ProfileInfoWidget.constants'

function isInfoMoneyWithinMax(value) {
  return (
    !value?.amount || parseAmount(value.amount) <= PROFILE_INFO_MONEY_MAX_AMOUNT
  )
}

export function getInfoWidgetValidationSchema({ config = EMPTY_LIST, t }) {
  const shape = {
    [PROFILE_INFO_NOTES_FIELD_NAME]: Yup.string()
      .ensure()
      .max(PROFILE_INFO_NOTES_MAX_LENGTH),
  }

  config.forEach(({ maxLength, name, type }) => {
    switch (type) {
      case ProfileInfoFieldType.SELECT:
      case ProfileInfoFieldType.DATE:
        shape[name] = Yup.mixed().nullable()
        break
      case ProfileInfoFieldType.CURRENCY:
        shape[name] = Yup.mixed()
          .nullable()
          .test({
            message: t('Error.MaxValueKey', {
              value: formatNumberWithSeparators(
                PROFILE_INFO_MONEY_MAX_AMOUNT,
                CURRENCY_FORMAT_OPTIONS
              ),
            }),
            test: isInfoMoneyWithinMax,
          })
        break
      case ProfileInfoFieldType.EMAIL:
        shape[name] = Yup.string()
          .ensure()
          .email(t('Widget.InfoEmailInvalidKey'))
          .max(maxLength)
        break
      case ProfileInfoFieldType.IBAN:
        shape[name] = Yup.string()
          .ensure()
          .max(maxLength)
          .test({
            message: t('Error.IncorrectIBANKey'),
            test: value => !value || isValidIban(value),
          })
        break
      case ProfileInfoFieldType.BIC:
        shape[name] = Yup.string()
          .ensure()
          .max(maxLength)
          .matches(REG_EXP_BIC, {
            excludeEmptyString: true,
            message: t('Error.IncorrectBICKey'),
          })
        break
      default:
        shape[name] = Yup.string().ensure().max(maxLength)
    }
  })

  return Yup.object(shape)
}
